module.exports = "/_next/static/images/loading_12-1acc1a973cfbdb598a930e9abb4a8a8b.png";